<template>
<div>
    <pt-reward-grant-form-with-data ref="form" @submitSuccess="submitSuccess" fromType="manual"></pt-reward-grant-form-with-data>
      <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
import PtRewardGrantFormWithData from './withData'
export default {
  components: {
    PtRewardGrantFormWithData
  },
  props: {
  },
  data () {
    return {
      submitLoading: false
    }
  },
  methods: {
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    },
    submitSuccess (val) {
      this.submitLoading = val
    }
  }

}
</script>
<style module lang="less">

</style>
